import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './store/AuthContext';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import HomePage from './pages/HomePage';
import ScanDetails from './pages/ScanDetails';
import ProfilePage from './pages/ProfilePage';
import UserManagementPage from './pages/admin/UserManagementPage';
import AdminSettings from './pages/admin/AdminSettings';
import MissionStatusPage from './pages/admin/MissionStatusPage';
import PromptEditorPage from './pages/admin/PromptEditorPage';
import ScoutParamsPage from './pages/admin/ScoutParamsPage';
import IntelPage from './pages/IntelPage';
import OpportunitiesPage from './pages/OpportunitiesPage';
import NewOpportunityPage from './pages/NewOpportunityPage';
import OpportunityDetailPage from './pages/OpportunityDetailPage';
import './index.css';

const PrivateRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) return <div>Initializing mission systems...</div>;
  if (!token) return <Navigate to="/login" />;

  return <DashboardLayout>{children}</DashboardLayout>;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/scan/:id" element={
            <PrivateRoute>
              <ScanDetails />
            </PrivateRoute>
          } />
          <Route path="/profile" element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          } />
          <Route path="/admin/users" element={
            <PrivateRoute>
              <UserManagementPage />
            </PrivateRoute>
          } />
          <Route path="/admin/settings" element={
            <PrivateRoute>
              <AdminSettings />
            </PrivateRoute>
          } />
          <Route path="/admin/status" element={
            <PrivateRoute>
              <MissionStatusPage />
            </PrivateRoute>
          } />
          <Route path="/admin/prompts" element={
            <PrivateRoute>
              <PromptEditorPage />
            </PrivateRoute>
          } />
          <Route path="/admin/scout-params" element={
            <PrivateRoute>
              <ScoutParamsPage />
            </PrivateRoute>
          } />
          <Route path="/intel" element={
            <PrivateRoute>
              <IntelPage />
            </PrivateRoute>
          } />
          <Route path="/opportunities" element={
            <PrivateRoute>
              <OpportunitiesPage />
            </PrivateRoute>
          } />
          <Route path="/opportunities/new" element={
            <PrivateRoute>
              <NewOpportunityPage />
            </PrivateRoute>
          } />
          <Route path="/opportunities/:id" element={
            <PrivateRoute>
              <OpportunityDetailPage />
            </PrivateRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
